import React, { useContext, useEffect } from 'react';

import { FILTERS } from '../../../../constants/banner';
import { BannerView } from '../../../../components/banner';

import styles from './banner.module.scss';
import { DealRoomContext } from '../context';
import { DealRoomEditState, DealRoomBanner } from 'src/types/dealRoom';

interface BannerFiltersProps {
  dealRoom: DealRoomEditState;
}

const BannerFilters: React.FC<BannerFiltersProps> = ({ dealRoom }) => {
  const dealRoomContext = useContext(DealRoomContext);

  const banner = dealRoom.banner;
  const [originalBanner, setOriginalBanner] = React.useState({
    filter: banner?.filter,
    overlayColor: banner?.overlayColor,
  });

  useEffect(() => {
    setOriginalBanner({
      filter: banner?.filter,
      overlayColor: banner?.overlayColor,
    });
  }, []);

  const updateFilters = (value : any) => {
    dealRoomContext.updateDealRoomProperty('banner', {
      ...banner,
      ...value,
    });
  }

  const handleClick = (value: any) => {
    updateFilters(value);
    setOriginalBanner(value);
  }
  
  const handleMouseOver = (value: any) => { 
    updateFilters(value);
  }

  const handleMouseOut = () => {
    updateFilters({
      filter: originalBanner?.filter,
      overlayColor: originalBanner?.overlayColor,
    });
  }

  if(!banner) {
    return null;
  }

  return (
    <div className={styles.bannerFilters}>
      <h2>Choose the filter you want to apply</h2>
      <div className={styles.filters}>
        {FILTERS.map((filter) => {

          const bannerItem = {
            ...banner!,
            ...filter.value,
            filter: filter.value.filter ?? undefined,
          } as unknown as DealRoomBanner;

          return (
            <div key={filter.label} className={styles.filter} 
              onClick={() => {
                handleClick(filter.value);
              }}
              onMouseOver={() => handleMouseOver(filter.value)}
              onMouseOut={handleMouseOut}
            >
              <BannerView banner={bannerItem} height={200} />
            </div>
          );
        })}
      </div>
    </div>
  );
}

export { BannerFilters };